// @ts-check
import StudyItem from "../models/studies/list";

/**
 * @param {StudyItem} study
 */
function imageQrGenerator(study) {
  const qrContainer = document.getElementById("QR");
  if (!qrContainer) {
    alert("No se encontro el contenedor del QR");
    return;
  }
  const originalCanvas = qrContainer.querySelector("canvas");
  if (!originalCanvas) {
    alert("No se encontro el canvas del QR");
    return;
  }
  const nombre = study.getPatientName(); // Ejemplo de nombre largo

  const tempCanvas = document.createElement("canvas");
  const ctx = tempCanvas.getContext("2d");
  if (!ctx) {
    alert("No se pudo obtener el contexto del canvas");
    return;
  }
  const extraHeight = 50;
  tempCanvas.width = originalCanvas.width;
  tempCanvas.height = originalCanvas.height + extraHeight;

  // 1. Fondo blanco
  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);

  // 2. Dibujar QR
  ctx.drawImage(originalCanvas, 0, 0);

  // --- LÓGICA DE AJUSTE DE TEXTO ---
  let fontSize = 20; // Tamaño inicial deseado
  const paddingManual = 10; // Margen para que no toque los bordes

  ctx.fillStyle = "black";
  ctx.textAlign = "center";

  // Bucle para reducir el tamaño si el texto es muy ancho
  do {
    ctx.font = `bold ${fontSize}px Arial`;
    fontSize--;
  } while (
    ctx.measureText(nombre).width > tempCanvas.width - paddingManual &&
    fontSize > 8
  );

  // 3. Dibujar el texto ya ajustado
  ctx.fillText(nombre, tempCanvas.width / 2, originalCanvas.height + 30);
  // ---------------------------------

  tempCanvas.toBlob((blob) => {
    if (!blob) {
      alert("No se pudo crear el blob");
      return;
    }
    const item = new window.ClipboardItem({ "image/png": blob });
    navigator.clipboard.write([item]).then(() => {
      alert("Copiado con texto ajustado");
    });
  });
}

export default imageQrGenerator;
